import Link from 'next/link';
import { motion } from 'framer-motion';
import { map, size } from 'lodash';
import { Button } from '@/components/shared/Button';
import Heading from '@/components/shared/Heading';
import TextComponent from '@/components/shared/Text';
import type { Banner } from '@/graphql/common/types';
import { textContainerVariant, textVariants } from './variants';

type TextProps = {
  activeIndex: number;
  banner: Banner;
  activeDrag?: boolean;
  onPrevious: () => void;
  onNext: () => void;
};
export const Text = ({
  activeIndex,
  banner,
  activeDrag = false,
  onPrevious,
  onNext
}: TextProps) => {
  const dragEndHandler = (dragInfo: any) => {
    const draggedDistance = dragInfo.offset.x;
    const swipeThreshold = 50;
    if (draggedDistance > swipeThreshold) {
      onPrevious();
    } else if (draggedDistance < -swipeThreshold) {
      onNext();
    }
  };

  return (
    <motion.div
      key={activeIndex}
      variants={textContainerVariant}
      initial="hidden"
      animate="visible"
      drag={activeDrag ? 'x' : undefined}
      dragConstraints={{ left: 0, right: 0 }}
      dragElastic={1}
      onDragEnd={(_, dragInfo) => dragEndHandler(dragInfo)}
      className="box-content flex-1 overflow-hidden px-6 pt-10 lg:px-12 lg:pt-12 "
    >
      <motion.div variants={textVariants} className="flex flex-col">
        <div className="flex flex-col gap-2">
          <TextComponent
            className="text-xs font-regular uppercase text-white lg:text-sm/[18px]"
            asChild
          >
            <p>{banner.subText}</p>
          </TextComponent>
          <Heading
            variant="h1"
            display
            className="text-[1.875rem]/[2.5rem] text-white lg:text-4xl/[3rem] xl:text-5xl/[3.5rem] 2xl:text-[3.5rem]/[3.875rem] 3xl:text-[4.5rem]/[5rem]"
            asChild
          >
            <h2>{banner.title}</h2>
          </Heading>
        </div>

        {size(banner.actions) > 0 && (
          <div className="mt-6 flex gap-4 lg:mt-8">
            {map(banner.actions, (item) => (
              <Button variant="light" asChild key={item.link.id}>
                <Link
                  href={item.link?.url ?? ''}
                  aria-label={item.link?.ariaLabel ?? ''}
                  target={item.link?.target && `_${item.link?.target}`}
                >
                  {item.link.label}
                </Link>
              </Button>
            ))}
          </div>
        )}
      </motion.div>
    </motion.div>
  );
};
